import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
    name: 'currencyFormat', pure: false // impure pipe because of language change
    ,
    standalone: false
})
export class CurrencyFormatPipe implements PipeTransform {

  constructor(private translate: TranslateService) {}

  transform(value: any, args?: any): any {
    try {
      let currencyCode = 'EUR';
      if (args) {
        currencyCode = args;
      }
      return (new CurrencyPipe(this.translate.currentLang)).transform(value, currencyCode, 'code');
    } catch (e) {
      console.error(e);
      return value;
    }
  }

}
